<template>
  <div class="review" v-if="item.comment && item.rate">
    <div class="review-info">
      <div class="review-icon">
        <img v-if="item.author.picture" :src="item.author.picture.slug | media({width: '64'})">
        <img v-if="!item.author.picture" src="/beta/static/img/admin/avatars/default-user-64.png" width="64">
      </div>      
      <rating class="review-star" :rate="item.rate"></rating>
      <div class="review-name">{{ item.author.nickname | `${item.author.firstName} ${item.author.lastName}` }}</div>
      <div class="review-date">{{ item.date | moment('MM/DD/YYYY') }}</div>
    </div>
    <div class="review-message">
      {{ item.comment }}
    </div>
  </div>
</template>
<script>
import Rating from '@/components/Rating'

export default {
  name: 'Review',
  props: ['item'],
  components: { rating: Rating }
}
</script>



// WEBPACK FOOTER //
// src/components/Review.vue